import { AuthRedirectTarget } from "@rosette/ts/src/auth/check/AuthRedirectTarget.js";
import type { AuthCheck } from "@rosette/ts/src/auth/check/AuthCheck.js";
import { Path } from "@rosette/ts/src/util/Path.js";
import { assertNever } from "@rosette/ts/src/util/tsutils.js";


export function getAuthRedirectPath(
    target: AuthRedirectTarget | AuthCheck,
    redirectPathname?: string,
): Path {
    if (typeof target !== "string") {
        target = target.getRedirectTarget();
    }
    switch (target) {
        case AuthRedirectTarget.SIGN_IN:
            return new Path("/login")
                .withOptionalParam("redirect", redirectPathname);
        case AuthRedirectTarget.REGISTER:
            return new Path("/register")
                .withOptionalParam("redirect", redirectPathname);
        case AuthRedirectTarget.HOME:
            return new Path("/");
        case AuthRedirectTarget.ACCOUNT_SETUP:
            return new Path("/setup");
        case AuthRedirectTarget.DELETION_STATUS:
            return new Path("/account-deletion-status");
        default:
            return assertNever(target);
    }
}
